import React from 'react';
import Header from "../components/header/Header";
import SkeletonProductTop from "./skeletonProductTop/SkeletonProductTop";
import SkeletonProductSlider from "./skeletonProductSlider/SkeletonProductSlider";
import Footer from "../components/footer/Footer";

const SkeletonSingleProduct = () => {
    return (
        <div className="skeleton-single-product-wrapper">
            <Header/>
            <SkeletonProductTop/>
            <div className="skeleton-bottom-slider">
            <SkeletonProductSlider/>
            </div>
            <Footer/>
        </div>
    );
};

export default SkeletonSingleProduct;
